import { z } from 'zod';

/** Cabine no vocabulário da tool do agents (`search_flights`, minúsculas) —
 *  voll-apollo usa MAIÚSCULAS. Compartilhada pelo resumo pré-busca
 *  (`flight_search_confirmation`) e pelo eco de busca dos cards de oferta. */
export const ChatUiFlightCabinSchema = z.enum(['economy', 'premium', 'business', 'first']);
